import React from 'react';
import FormsElementContainer, { FormsElementContainerModifier } from '../FormsElementContainer/FormsElementContainer';
import Btn from '../../../Btn/Btn';

type FormSubmitButtonProps = {
  buttonLabel: string;
  ariaDescribedBy?: string;
  enabled: boolean;
};

export function FormSubmitButton({ buttonLabel, ariaDescribedBy, enabled }: FormSubmitButtonProps) {
  return (
    <FormsElementContainer modifier={FormsElementContainerModifier.BUTTON_GROUP_RIGHT}>
      <Btn
        cssClass="btn--single-action btn--single-action-yes forms__button"
        text={buttonLabel}
        ariaDisabled={!enabled}
        type={enabled ? 'submit' : 'button'}
        ariaDescribedBy={ariaDescribedBy}
      />
    </FormsElementContainer>
  );
}
